import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DiagnosticCollectionDto, DiagnosticDto, DiagnosticLevel } from '../../../services/api.services';
import { DiagnosticDetailsDialogComponent } from './diagnostic-details.dialog';

@Component({
  selector: 'app-diagnostic-collection',
  templateUrl: './diagnostic-collection.component.html',
  styleUrls: ['./diagnostic-collection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DiagnosticCollectionComponent implements OnInit, OnChanges {
  @Input('diagnostics') diagnosticCollection: DiagnosticCollectionDto;

  diagnostics: DiagnosticDto[] = [];

  tableColumns = ['timestamp', 'level', 'message', 'properties'];

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.diagnosticCollection) {
      this.diagnostics = this.diagnosticCollection?.diagnostics ?? [];
    }
  }


  trackByDiagnostic(index: number, d: DiagnosticDto) {
    return index;
  }


  formatLevel(d: DiagnosticDto) {
    switch (d.level) {
      case DiagnosticLevel.Debug: return 'Debug';
      case DiagnosticLevel.Information: return 'Information';
      case DiagnosticLevel.Warning: return 'Warning';
      case DiagnosticLevel.Error: return 'Error';
    }

    return 'Unknown';
  }

  formatLevelClass(d: DiagnosticDto) {
    return `diagnostic-level__${this.formatLevel(d).toLowerCase()}`;
  }

  formatMessage(d: DiagnosticDto) {
    let properties = new Map<string, any>();

    for (let key of Object.keys(d.properties)) {
      properties.set(key.toLowerCase(), d.properties[key]);
    }

    return d.message.replace(/\{[^\}]+\}/gi, m => {
      return properties.get(m.substr(1, m.length - 2).toLowerCase()) ?? m;
    });
  }

  formatProperties(d: DiagnosticDto) {
    return JSON.stringify(d.properties, null, 2);
  }


  clickRow(d: DiagnosticDto) {
    this.dialog.open(DiagnosticDetailsDialogComponent, {
      width: '800px',
      hasBackdrop: true,
      closeOnNavigation: true,
      disableClose: false,
      data: {
        message: this.formatMessage(d),
        properties: this.formatProperties(d)
      }
    });
  }
};
